import React, { useState, useEffect } from "react";
import * as PermissionsConstants from "../../const/constants";
import { Link } from "react-router-dom";
import data from "../../assets/apiRoutes.json";
import axios from "axios";
import { Button } from 'devextreme-react/button';
import { connect } from "react-redux";
import DeleteTransactionDialog from "./Dialoges/DeleteTransactionDialog";
import { Reset_Change_Receipt_Items } from "../../redux/actions/receipt";
import { useDispatch } from "react-redux";
import { CARRIER_LOGIN_TYPE } from "../../common/permissions";
import "./wmmodulestyle.css";
import { useHistory } from "react-router-dom";

const TransactionCrudButtons = (props) => {
  
  const dispatch = useDispatch();
  const history = useHistory();
  const [open, setOpen] = React.useState(false);
  const [allowedReceiptCreateBtn, setAllowedReceiptCreateBtn] = useState(false);
  const [allowedReceiptUpdateBtn, setAllowedReceiptUpdateBtn] = useState(false);
  const [allowedReceiptDeleteBtn, setAllowedReceiptDeleteBtn] = useState(false);
  const [allowedShipmentCreateBtn, setAllowedShipmentCreateBtn] =
    useState(false);
  const [allowedShipmentUpdateBtn, setAllowedShipmentUpdateBtn] =
    useState(false);
  const [allowedShipmentDeleteBtn, setAllowedShipmentDeleteBtn] =
    useState(false);
  const [allowedReceiptCustomerTransactionCreateBtn, setAllowedReceiptCustomerTransactionCreateBtn] = useState(false);
  const [allowedReceiptCustomerTransactionUpdateBtn, setAllowedReceiptCustomerTransactionUpdateBtn] = useState(false);
  const [allowedShipmentCustomerTransactionCreateBtn, setAllowedShipmentCustomerTransactionCreateBtn] = useState(false);
  const [allowedShipmentCustomerTransactionUpdateBtn, setAllowedShipmentCustomerTransactionUpdateBtn] = useState(false);
  var accessToken = props.oidc.user.access_token;

  let validateRolePermissions = [];
  const validateTransactionCreateBtn = (perm) => {
    if (perm === PermissionsConstants.TransactionReceiptCreate) {
      setAllowedReceiptCreateBtn(true);
    } else if (perm === PermissionsConstants.TransactionReceiptCustomerTransactionCreate) {
      setAllowedReceiptCustomerTransactionCreateBtn(true);
    } else if (perm === PermissionsConstants.TransactionShipmentCreate) {
      setAllowedShipmentCreateBtn(true);
    } else if (perm === PermissionsConstants.TransactionShipmentCustomerTransactionCreate) {
      setAllowedShipmentCustomerTransactionCreateBtn(true);
    }
  };
  const validateTransactionEditBtn = (perm) => {
    if (perm === PermissionsConstants.TransactionReceiptUpdate) {
      setAllowedReceiptUpdateBtn(true);
    } else if (perm === PermissionsConstants.TransactionReceiptCustomerTransactionUpdate) {
      setAllowedReceiptCustomerTransactionUpdateBtn(true);
    } else if (perm === PermissionsConstants.TransactionShipmentUpdate) {
      setAllowedShipmentUpdateBtn(true);
    } else if (perm === PermissionsConstants.TransactionShipmentCustomerTransactionUpdate) {
      setAllowedShipmentCustomerTransactionUpdateBtn(true);
    }
  };

  const validateTransactionDeleteBtn = (perm) => {
    if (perm === PermissionsConstants.TransactionReceiptDelete) {
      setAllowedReceiptDeleteBtn(true);
    } else if (perm === PermissionsConstants.TransactionShipmentDelete) {
      setAllowedShipmentDeleteBtn(true);
    }
  };
  useEffect(() => {
    // Reset all permission states
    setAllowedReceiptCreateBtn(false);
    setAllowedReceiptUpdateBtn(false);
    setAllowedReceiptDeleteBtn(false);
    setAllowedShipmentCreateBtn(false);
    setAllowedShipmentUpdateBtn(false);
    setAllowedShipmentDeleteBtn(false);
    setAllowedReceiptCustomerTransactionCreateBtn(false);
    setAllowedReceiptCustomerTransactionUpdateBtn(false);
    setAllowedShipmentCustomerTransactionCreateBtn(false);
    setAllowedShipmentCustomerTransactionUpdateBtn(false);
    
    validateRolePermissions = [];
    Object.entries(props.ReceiptReducer.rolePermissions).map(([key, value]) => {
      value.forEach((element) => {
        validateRolePermissions.push(key + element);
      });
    });
    validateRolePermissions.map((p) => {
      validateTransactionCreateBtn(p);
      validateTransactionEditBtn(p);
      validateTransactionDeleteBtn(p);
    });
  }, [props.ReceiptReducer.rolePermissions]);
  const deleteTransaction = (rowid) => {
    var deleteReceiptObject = {
      rowid: rowid,
      dbName:
        props.ReceiptReducer.wmTransactionDatabase !== ""
          ? props.ReceiptReducer.wmTransactionDatabase
          : "",
    };
    axios
      .post(
        `${window._env_.REACT_APP_APIS}/${data.Receipt.DeleteTransactions}`,
        deleteReceiptObject,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
          },
        }
      )
      .then((resp) => {
        props.loadTransactions();
      });
    handleClose();
  };
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
 
  const getDeleteButtonDisabled = () => {
    const useWebOrder = props.oidc?.user?.profile?.hasOwnProperty("USEWEBORDER") 
      ? props.oidc.user.profile.USEWEBORDER 
      : "N";
    const recordType = props.recordType ? String(props.recordType).toUpperCase() : null;
    
    // If USEWEBORDER == Y and recordType == W, then allow delete
    if (useWebOrder === "Y" && recordType === "W") {
      return props.disable; // Only use the base disable prop
    }
    // Else if USEWEBORDER == Y and recordType != W, then don't allow delete
    else if (useWebOrder === "Y" && recordType !== "W" && recordType !== null) {
      return true; // Disable delete
    }
    // Else, continue previous logic
    else {
      return (props.disableEditDelete == true ? true : props.disable);
    }
  };
  const [viewBtnURL, setviewBtnURL] = React.useState(props.permission ===
    PermissionsConstants.TransactionReceipt
    ? "/wm/transaction/view-receipt"
    : "/wm/transaction/view-shippment");
  const [changeBtnURL, setchangeBtnURL] = React.useState(props.permission ===
    PermissionsConstants.TransactionReceipt
    ? "/wm/transaction/change-receipt"
    : "/wm/transaction/change-shippment");
  const [createBtnURL, setcreateBtnURL] = React.useState(props.permission ===
    PermissionsConstants.TransactionReceipt
    ? "/wm/transaction/create-receipt"
    : "/wm/transaction/create-shippment");
  const [viewAdjustmentBtnURL, setviewAdjustmentBtnURL] = React.useState(props.permission ===
    PermissionsConstants.TransactionReceipt ||
    props.permission ===
    PermissionsConstants.TransactionAdjustment
    ? "/wm/transaction/view-receipt"
    : "/wm/transaction/view-shippment");

  return (
    <>
      <>
        {props.permission !== PermissionsConstants.TransactionAdjustment ? (
          <>
            <Button
              disabled={(props.disable)}
              type="default"
              text="View"
              onClick={() => { history.push(viewBtnURL); }}
            >
            </Button>
            {(() => {
              const useWebOrder = props.oidc?.user?.profile?.hasOwnProperty("USEWEBORDER") 
                ? props.oidc.user.profile.USEWEBORDER 
                : "N";
              
              // If USEWEBORDER == Y, display Change Transaction
              if (useWebOrder === "Y" && 
                  props.permission === PermissionsConstants.TransactionReceipt &&
                  (!props.oidc.user.profile.hasOwnProperty("LOGINTYPEID") || props.oidc.user.profile.LOGINTYPEID != CARRIER_LOGIN_TYPE)) {
                return (
                  <Button
                  disabled={(props.disable)}
                    onClick={() => {
                      let resetItems = [];
                      dispatch(Reset_Change_Receipt_Items(resetItems));
                      history.push(`/wm/transaction/change-customer-transaction?rowId=${props.rowid}`);
                    }}
                    className="gridTopButton"
                    text="Change Transaction"
                    type="default"
                  >
                  </Button>
                );
              }
              // Else, use previous logic for Change button
              else if (props.permission === PermissionsConstants.TransactionReceipt &&
                       allowedReceiptUpdateBtn &&
                       (!props.oidc.user.profile.hasOwnProperty("LOGINTYPEID") || props.oidc.user.profile.LOGINTYPEID != CARRIER_LOGIN_TYPE)) {
                return (
                  <Button
                    disabled={(props.disableEditDelete == true ? true : props.disable)}
                    onClick={() => {
                      let resetItems = [];
                      dispatch(Reset_Change_Receipt_Items(resetItems));
                      history.push(`/wm/transaction/change-receipt?rowId=${props.rowid}`);
                    }}
                    className="gridTopButton"
                    text="Change"
                    type="default"
                  >
                  </Button>
                );
              }
              return "";
            })()}
            {(() => {
              const useWebOrder = props.oidc?.user?.profile?.hasOwnProperty("USEWEBORDER") 
                ? props.oidc.user.profile.USEWEBORDER 
                : "N";
              
              // If USEWEBORDER == Y, display Change Transaction
              if (useWebOrder === "Y" && 
                  props.permission === PermissionsConstants.TransactionShipment &&
                  (!props.oidc.user.profile.hasOwnProperty("LOGINTYPEID") ||
                   props.oidc.user.profile.LOGINTYPEID !== CARRIER_LOGIN_TYPE)) {
                return (
                  <Button
                  disabled={(props.disable)}
                    onClick={() => {
                      let resetItems = [];
                      dispatch(Reset_Change_Receipt_Items(resetItems));
                      history.push(`/wm/transaction/change-customer-transaction?rowId=${props.rowid}`);
                    }}
                    className="gridTopButton"
                    text="Change Transaction"
                    type="default"
                  >
                  </Button>
                );
              }
              // Else, use previous logic for Change button
              else if (props.permission === PermissionsConstants.TransactionShipment &&
                       allowedShipmentUpdateBtn &&
                       (!props.oidc.user.profile.hasOwnProperty("LOGINTYPEID") ||
                        props.oidc.user.profile.LOGINTYPEID !== CARRIER_LOGIN_TYPE)) {
                return (
                  <Button
                    disabled={(props.disableEditDelete == true ? true : props.disable)}
                    onClick={() => {
                      let resetItems = [];
                      dispatch(Reset_Change_Receipt_Items(resetItems));
                      history.push(`/wm/transaction/change-shippment?rowId=${props.rowid}`);
                    }}
                    className="gridTopButton"
                    text="Change"
                    type="default"
                  >
                  </Button>
                );
              }
              return "";
            })()}
            {props.permission === PermissionsConstants.TransactionReceipt &&
              allowedReceiptDeleteBtn &&
              (!props.oidc.user.profile.hasOwnProperty("LOGINTYPEID") || props.oidc.user.profile.LOGINTYPEID != CARRIER_LOGIN_TYPE) ? (
              <Button
                disabled={getDeleteButtonDisabled()}
                onClick={handleClickOpen}
                className="gridTopButton"
                text="Delete"
                type="default"
              >
              </Button>
            ) : (
              ""
            )}
            {props.permission ===
              PermissionsConstants.TransactionShipment &&
              allowedShipmentDeleteBtn ? (
              <Button
                disabled={getDeleteButtonDisabled()}
                onClick={handleClickOpen}
                className="gridTopButton"
                text="Delete"
                type="default"
              >
              </Button>
            ) : (
              ""
            )}
            {(() => {
              const useWebOrder = props.oidc?.user?.profile?.hasOwnProperty("USEWEBORDER") 
                ? props.oidc.user.profile.USEWEBORDER 
                : "N";
              
              // If USEWEBORDER == Y, display Create Transaction
              if (useWebOrder === "Y" && props.permission === PermissionsConstants.TransactionReceipt) {
                return (
                  <Button
                  
                    className="gridTopButton"
                    text="Create Transaction"
                    onClick={() => { history.push("/wm/transaction/create-customer-transaction"); }}
                    type="default"
                  >
                  </Button>
                );
              }
              // Else, use previous logic for Create button
              else if (props.permission === PermissionsConstants.TransactionReceipt && allowedReceiptCreateBtn) {
                return (
                  <Button
                    className="gridTopButton"
                    text="Create"
                    disabled={props.permission === PermissionsConstants.TransactionReceipt ? false : true}
                    onClick={() => { history.push("/wm/transaction/create-receipt"); }}
                    type="default"
                  >
                  </Button>
                );
              }
              return "";
            })()}
            {(() => {
              const useWebOrder = props.oidc?.user?.profile?.hasOwnProperty("USEWEBORDER") 
                ? props.oidc.user.profile.USEWEBORDER 
                : "N";
              
              // If USEWEBORDER == Y, display Create Transaction
              if (useWebOrder === "Y" && props.permission === PermissionsConstants.TransactionShipment) {
                return (
                  <Button
                    className="gridTopButton"
                    text="Create Transaction"
                    onClick={() => { history.push("/wm/transaction/create-customer-transaction"); }}
                    type="default"
                  >
                  </Button>
                );
              }
              // Else, use previous logic for Create button
              else if (props.permission === PermissionsConstants.TransactionShipment && allowedShipmentCreateBtn) {
                return (
                  <Button
                    className="gridTopButton"
                    text="Create"
                    disabled={props.permission === PermissionsConstants.TransactionShipment ? false : true}
                    onClick={() => { history.push("/wm/transaction/create-shippment"); }}
                    type="default"
                  >
                  </Button>
                );
              }
              return "";
            })()}

          </>
        ) : (
          <>
            <Button
              disabled={(props.disable)}
              className="gridTopButton"
              type="default"
              text="View"
              onClick={() => { history.push(viewAdjustmentBtnURL); }}
            >
            </Button>
          </>
        )}
      </>
      <DeleteTransactionDialog
        loadTransactions={props.loadTransactions}
        open={open}
        rowid={props.rowid}
        handleClose={handleClose}
        transactionNumber={props.deletedTransactionNumber}
        openDialog={open}
        onClose={handleClose}
      />
    </>
  );
};

function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}
export default connect(mapStateToProps)(TransactionCrudButtons);
